import {useCallback, KeyboardEvent} from "react";

type Params<T> = {
    items: T[];
    cursor: number;
    setCursor: (cursor: number) => void;
    onSelect?: (
        item: T,
        index: number
    ) => void;
};

export const useSearchNavigation = <T>(
    {
        items,
        cursor,
        setCursor,
        onSelect,
    }: Params<T>
) => {
    const handleKeyDown = useCallback((e: KeyboardEvent) => {
        if (!items.length) return;

        if (e.key === "ArrowUp") {
            e.preventDefault();

            const nextCursor = cursor > 0 ? cursor - 1 : items.length - 1;

            setCursor(nextCursor);

            onSelect?.(items[nextCursor], nextCursor);
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();

            const nextCursor = cursor < items.length - 1 ? cursor + 1 : 0;

            setCursor(nextCursor);

            onSelect?.(items[nextCursor], nextCursor);
        }

        if (e.key === "Enter") {
            e.preventDefault();
        }
    }, [items, cursor, setCursor, onSelect]);

    return {
        handleKeyDown,
    };
};
